import e, { useEffect as t } from "react";
import { OptionButton as a } from "../../../../buttons/OptionButton/OptionButton.js";
import { AccountCircle as n } from "../../../../general/AccountCircle/AccountCircle.js";
import { t as i } from "../../../../../i18/index.js";
import { isEmail as o } from "../../../../../utils/validators/index.js";
import { Icon as r } from "../../../../general/Icon/Icon.js";
import { tip as l } from "../../../../forms/Tooltip/Tooltip.js";
import "../../../../../../node_modules/classnames/index.js";
import { ProfileItemsRow as m } from "./ProfileItemsRow.js";
function c(t) {
  return e.createElement("div", {
    className: "profile-items-inner profile-items-inner__user-container"
  }, e.createElement(n, {
    className: "profile-items-inner__account-circle",
    avatar: t.avatar,
    height: "38.5",
    width: "38.5"
  }), e.createElement("div", {
    className: "profile-items-inner__user"
  }, e.createElement("div", {
    className: "profile-items-inner__username"
  }, t.username), e.createElement("div", {
    className: "profile-items-inner__email"
  }, t.email)));
}
var s = e.createElement("div", {
  className: "top-bar__account-title"
}, e.createElement(n, null));
function p(p) {
  function u(t) {
    return null == t ? void 0 : t.map(function (t, a) {
      return e.createElement(m, {
        key: a,
        name: t.name,
        path: t.path,
        type: t.type,
        target: t.target,
        action: t.action,
        onClick: t.onClick,
        active: t.active
      });
    });
  }
  var f,
    d,
    v,
    _,
    g = e.createElement("div", {
      className: "top-bar__account-title"
    }, p.impersonated ? e.createElement(r, {
      fw: !0,
      regular: !0,
      className: "top-bar__account-impersonate-icon",
      name: "fa-eye"
    }) : e.createElement(n, {
      avatar: p.avatar
    }), e.createElement("div", {
      className: "top-bar__account-username"
    }, o(p.username) ? null == (f = p.username) ? void 0 : f.split("@")[0] : null == (d = p.username) ? void 0 : d.split(" ")[0]));
  return t(function () {
    l({
      className: "kaseya-ui-top-bar__account-title-tooltip",
      target: document.querySelector(".top-bar__account-title"),
      content: i("topbar.my-account"),
      options: {
        position: "bottom"
      }
    });
  }, []), e.createElement(a, {
    className: "top-bar__account-dropdown-container",
    label: p.mobile ? s : g,
    arrowSize: 0,
    closeOnClickInside: !0,
    popoverClassName: p.popoverClassName,
    onOpen: p.onAccountMenuOpen,
    arrowPosition: "right",
    pointTo: "right",
    edgeOffset: 0
  }, e.createElement(c, {
    avatar: p.avatar,
    username: p.username,
    email: p.email
  }), (p.profileSettingsLink || (null === (v = p.topSectionProfileData) || void 0 === v ? void 0 : v.length)) && e.createElement("div", {
    className: "profile-items-inner"
  }, p.profileSettingsLink && e.createElement(m, {
    name: i("my-settings"),
    path: p.profileSettingsLink,
    type: "link"
  }), u(p.topSectionProfileData)), !!(null === (_ = p.midSectionProfileData) || void 0 === _ ? void 0 : _.length) && e.createElement("div", {
    className: "profile-items-inner profile-items-inner__mid"
  }, u(p.midSectionProfileData)), e.createElement("div", {
    className: "profile-items-inner"
  }, u(p.bottomSectionProfileData), e.createElement(m, {
    name: i("log-out"),
    path: p.logoutLink,
    type: "link",
    onClick: p.onLogout
  })));
}
export { p as ProfileItems, c as ProfileUser };